export default "__VITE_ASSET__WLAYccv9__"